export const getStorageValue = (key: string) => {
  return localStorage.getItem(key);
};

export const setStorageValue = (key: string, value: string) => {
  return localStorage.setItem(key, value);
};

export const removeStorageValue = (key: string) => {
  return localStorage.removeItem(key);
};

export const clearStorage = () => {
  return localStorage.clear();
};
